<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Place Order</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" dense>
                    <!-- 1000001621 -->
                    <v-col cols="12" sm="3">
                        <p><b>Enter Student PRN*</b></p>
                        <v-text-field outlined dense  type="text" v-model="prn" value="1000001621"></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b></b></p>
                        <br />
                        <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="fetchStudentData()">
                            Fetch</v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" allign="center" v-if="learner_details != ''" dense>
                  <v-col cols="12" sm="2" md="2"></v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="" md="6">
                                <p><b>Standard : </b> {{ learner_details[0].standard }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>DOB : </b> {{ learner_details[0].dob }}</p>
                            </v-col>
                            </v-row>
                             <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Mother Name : </b> {{ learner_details[0].mother_name }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Wallet Balance : </b> <b style="font-size: larger;" class="flash">{{ learner_details[0].balance }}</b> </p>
                            </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Parent Contact : </b> {{ learner_details[0].mobile_no }}</p>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <p><b>Parental Control : </b><v-icon color="black"
                                        @click="showParentalControlList()">mdi-eye</v-icon></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                                <v-col cols="12" sm="6" md="6">
                                    <p><b>Allergy: </b> {{ learner_details[0].allergy }}</p>
                                </v-col>
                                 <v-col cols="12" sm="6" md="6">
                                 </v-col>
                        </v-row> 
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <center>
                            <v-img width="150" :src="awspath + learner_details[0].photo_url" aspect-ratio="1"
                                class="grey lighten-2" style="border: 1px solid black;"></v-img>
                            <p><b>{{ learner_details[0].learner }}</b></p>
                        </center>
                    </v-col>
                    <v-col cols="12" sm="1" md="1"></v-col>
                </v-row>
       </v-card>

<!-- {{meal_details}} -->

    <v-card class="box" v-if="meal_details!=''">
        <br>
            <v-row justify="center" dense>
                                    <v-col cols="12" sm="3">
                                        <!-- <p><b>Today's Meal Menu</b></p> -->
                                        <v-text-field  outlined dense v-model="meal_details[0].name" label="Today's Meal Menu"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <!-- <p><b>Rate In Rs.</b></p> -->
                                        <v-text-field outlined dense type="text" disabled v-model="meal_details[0].rate" label="Rate In Rs."></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <!-- <p><b>Quantity</b></p> -->
                                        <v-text-field outlined dense type="number" v-model="quantity" label="Quantity"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="2" v-if="quantity != null">
                                        <!-- <p class="padding-bot"><b></b></p><br> -->
                                        <v-btn class="toolbar" outlined dense rounded :loading="loader"
                                            @click="PlaceMealOrder()">Place Order</v-btn>
                                    </v-col>
                                </v-row>
    </v-card>

<v-card class="box" v-if="student_canteen_order_list!=''">
  <v-data-table v-if="student_canteen_order_list != ''" class="elevation-1 mytable" dense
                    :headers="student_canteen_order_headers" :items="student_canteen_order_list">
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Today's Orders</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <br />
                    </template>
                    <!-- <template v-slot:[`item.cancel`]="{ item }">
                        <v-btn @click="cancelOrder(item)" class="mt-1 mb-1 v-icon-size" outlined rounded small
                            color="red">Cancel</v-btn>
                    </template> -->
                     <template v-slot:[`item.receipt`]="{ item }">
                        <v-tooltip top color="warning">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on"
                                    @click="print(item)">
                                    <!-- <v-icon color="warning">mdi-printer</v-icon>{{ item.orderid }}</v-btn -->
                                    <v-icon color="warning">mdi-printer</v-icon>Print</v-btn>
                            </template>
                            <span> Print Fee Receipt!!! </span>
                        </v-tooltip>
                    </template>
                </v-data-table>
</v-card>
  <v-dialog v-model="show_menu" persistent max-width="1200px" transition="dialog-bottom-transition">
                <v-card>
                    <v-card class="box">
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Parental Control Menu List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-data-table :headers="menu_headers" :items="parental_control_list"> </v-data-table>
                        </v-card-text>
                        <br />
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="show_menu = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_print" persistent max-width="1200px" transition="dialog-bottom-transition">
                <v-card>
                    <v-card class="box" v-if="order_details != ''">
                        <v-toolbar dense flat class="toolbar">
                            <v-toolbar-title>Print</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>

                            <v-card>
                                <v-simple-table dense class="elevation-1 table-container">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th colspan="4">
                                                    <center><strong>Canteen Receipt</strong></center>
                                                </th>
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <center><strong><b>WWS Canteen</b></strong></center>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">Date. : {{ order_details[0].transaction_date }}</td>
                                                <td colspan="2">Order Id : {{ order_details[0].orderid }}</td>
                                            </tr>
                                            <tr>
                                                <th>Menu</th>
                                                <th>Rate</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in order_details" :key="item.id">
                                                <td>{{ item.canteenmenu }}</td>
                                                <td>{{ item.rate }}</td>
                                                <td>{{ item.quantity }}</td>
                                                <td>{{ item.amount }}</td>
                                            </tr>
                                        </tbody>
                                        <tr>
                                            <td colspan="3">
                                            </td>
                                            <td colspan="1">
                                                <!-- <center><strong>Total In Rs. {{ total_order_amount }}</strong></center> -->
                                            </td>
                                        </tr>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-card-text>
                        <v-row justify="center" dense>
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printreceipt()"> <v-icon
                                    left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                        </v-row>

                        <br />
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog_print = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-dialog>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        dialog_print:false,
    loader: false,
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    quantity:1,
    prn: "",
    learner_details: [],
    show_stud_data: false,
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
       student_canteen_order_headers: [
            { text: "SR No", value: "count" },
            { text: "Order Id", value: "orderid" },
            { text: "Menu", value: "canteenmenu" },
            { text: "Rate", value: "rate" },
            { text: "Quantity", value: "quantity" },
            { text: "Total", value: "amount" },
            // { text: "Cancel", value: "cancel" },
            { text: "Receipt", value: "receipt" },
        ],
        menu_headers: [
        // { text: "SR No", value: "count" },
        { text: "Menu Id", value: "menuid" },
        { text: "Menu type", value: "canteenmenutype" },
        { text: "Menu Category", value: "canteenmenucategory" },
        { text: "Name", value: "name" },
    ],
      awspath:null,tenant:null,meal_details:[],student_canteen_order_list:[],parental_control_list:[],show_menu:false,temp_balance: 0,total_cart_value:0

  }),
   methods: {
       printreceipt() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        print(item) {
            this.total_order_amount = 0
            this.order_details = [];
            const data = {
                orderid: item.orderid,
            };
            this.overlay = true;
            axios
                .post("/Canteen/getOrderDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.order_details = res.data.canteen_order_list;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.dialog_print = true;
                    this.getOrderDetailsTotal()
                });
        },
         getTotalcartValue(){
             this.total_cart_value=0
                this.total_cart_value += parseFloat(this.quantity * this.meal_details[0].rate);
             return  this.total_cart_value
        },
      showParentalControlList() {
            this.parental_control_list = this.learner_details[0].canteen_menu_list;
            this.show_menu = true;
        },
    PlaceMealOrder() {
        if(this.quantity<=0){
            this.showSnackbar("red", "Please Enter Valid Quantity...");
            return
        }
         if (this.learner_details[0].balance <= 0) {
                this.showSnackbar("red", "Insufficient Balance Wallet...Please Recharge Your Wallet...");
                return;
            }
             this.getTotalcartValue();

             if (this.learner_details[0].balance < this.total_cart_value) {
                this.showSnackbar("red", "Insufficient Balance Wallet To Complete This Order...Please Recharge Your Wallet...");
                return;
            }
            // return
            const data = {
                prn: this.prn,
                menu_id: this.meal_details[0].id,
                quantity: this.quantity,
            };
            this.overlay = true;
            axios
                .post("/Canteen/PlaceMealOrder", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                       this.showSnackbar("green", "Order Placed Successfully...");
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.fetchStudentData()
                });
        },
      fetchStudentData() {
            const data = {
                prn: this.prn,
            };
            this.overlay = true;
            axios
                .post("/Canteen/fetchStudentData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                         this.meal_details=res.data.meal_details,
                        // alert(this.meal_details)
                         (this.student_canteen_order_list = res.data.student_canteen_order_list),
                        (this.learner_details = res.data.learner_details),
                        this.temp_balance = this.learner_details[0].balance
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    async viewStudentMedicalForm(item) {
      alert(item.id);
      localStorage.setItem("medical_form_no", item.id);
      try {
          const res = await axios.post("/HealthCard/generateReceipt", data);
          if (res.data.flag == "YES") {
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
    created() {
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
    },
   mounted() {
   // this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>